     
document.addEventListener('DOMContentLoaded', function() {
const packSizeSelector = document.querySelector('.pack-size-selector');
const btnplus = document.querySelector('.quantity-btn--plus');
const btnminus = document.querySelector('.quantity-btn--minus');   
const packSizeInput = document.getElementById('pack-size'); 
 packSizeInput.value = packSizeSelector.value;
    btnplus.addEventListener("click", updateCartLine);
    btnminus.addEventListener("click", updateCartLine);
function updateCartLine() {
      packSizeInput.value = packSizeSelector.value;
}});

